// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useExerciseSubmission } from '@hooks/mutations/ledger/useSubmission';
import { AppRewardConfiguration } from '@daml.js/utility-registry-v0/lib/Utility/Registry/V0/Configuration/AppReward';
import { ERR_ARC_APP_REWARD_CONFIG, SUC_ARC_APP_REWARD_CONFIG } from '../../../../utils/strings';

export const useArchiveAppRewardConfig = () => {
  const { submit } = useExerciseSubmission(
    AppRewardConfiguration.Archive,
    SUC_ARC_APP_REWARD_CONFIG,
    ERR_ARC_APP_REWARD_CONFIG,
  );
  return submit;
};
